export default {
  showAuthDialog: false,
  panoramaHeader: false
}
